import { SharedPermissionService } from '@agroone-front/shared'
import { UserPermissions } from '@agroone/entities'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PermissionService extends SharedPermissionService {
  protected getOfflinePermissions(): UserPermissions[] {
    return []
  }
}
